export default __webpack_public_path__ + "static/media/Ankit.4efb3c84.jpeg";